import regexes from '../regexes';

const getIdfromURL = () => {
  const url = window.location.href;
  const uuidRegex = regexes.UUID;
  const uuidMatch = url.match(uuidRegex);
  const uuid = uuidMatch ? uuidMatch[1] : '';
  return uuid;
};

export default getIdfromURL;
